module.exports = __webpack_public_path__ + "img/UberEats.92188398.png";